// Dependencies
import React from "react";

// Material UI Components
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

// Components
import SocialsLinks from "features/main/components/SocialsLinks/SocialsLinks.component";

// Helpers

// Styles
import { formatPriceString } from "helpers/string-format-helpers";
import { useStyles } from "./EvergreenHeader.styles";

const EvergreenHeader = ({ genericVehicle }) => {
  const classes = useStyles();

  if (!genericVehicle) {
    return (
      <>
        <div className={classes.container} id="evergreenHeader">
          <Skeleton className={classes.mobileCenteredText}>
            <Typography
              variant="h1"
              className={classes.dealershipTitle}
              data-cy="vehicle-name"
            >
              2020 carmake carmodel
            </Typography>
          </Skeleton>
          <div className={classes.skeleton}>
            <Skeleton className={classes.mobileCenteredText}>
              <Typography
                className={classes.price}
                variant="h2"
                data-cy="vehicle-price-header"
              >
                $25,000 - $50,000
              </Typography>
            </Skeleton>
          </div>
        </div>
      </>
    );
  }
  return (
    <div
      className={classes.container}
      id="evergreenHeader"
      data-component="EvergreenHeader"
    >
      <Typography
        variant="h1"
        className={classes.evergreenTitle}
        data-cy="vehicle-name"
      >
        {`${genericVehicle.model.make.name} ${genericVehicle.model.name}`}
      </Typography>
      <div className={classes.desktopFlex}>
        <Typography
          variant="h2"
          data-cy="vehicle-price"
          className={classes.priceRange}
        >
          {`Price: ${formatPriceString({ price: genericVehicle.msrp })}`}
        </Typography>
        <SocialsLinks />
      </div>
    </div>
  );
};

export default EvergreenHeader;
